/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */
import styled from '@emotion/styled';

import { token } from '@atlaskit/tokens';

export const PanelWrapper = styled.div({
  marginTop: token('space.negative.200'),
  paddingLeft: token('space.250'),
  button: {
    svg: {
      color: token('color.text.information'),
    },
  },
  '> div': {
    margin: `0 auto ${token('space.100')}`,
  },
  table: {
    marginTop: token('space.100'),
  },
});

export const PanelHeader = styled.span({
  color: token('color.text.information'),
});

export const LozengeContainer = styled.span({
  paddingLeft: token('space.100'),
});
